import * as ents from '@attain-apps/entities'

/**
 * Excel stores dates as serial numbers and uses the cell's `numFmt` property
 * to render those numbers as calendar dates. Date formatting therefore belongs
 * in this number-format model alongside the numeric formats.
 */
const DATE_FORMAT = 'm/d/yyyy'

/**
 * Tells Excel how to display a numeric or date cell value.
 */
export type NumberFormat = string
export namespace NumberFormat {
  /**
   * Produces a {@link NumberFormat} using the given
   * {@link ents.core.common.value.Info}
   */
  export function from(
    info?: Readonly<
      Replace.Properties<
        ents.core.common.value.Info,
        'type',
        | ents.core.common.value.types.Intrinsic.ForNumber
        | ents.core.common.value.types.Intrinsic.Date
        | undefined
      >
    >,
  ): NumberFormat
  export function from(
    info?: Readonly<ents.core.common.value.Info>,
  ): NumberFormat | undefined
  export function from({
    precision,
    type,
  }: Readonly<ents.core.common.value.Info> = {}): NumberFormat | undefined {
    if (type === ents.core.common.value.types.Intrinsic.Date) {
      return DATE_FORMAT
    }

    if (
      // We treat type === undefined as a generic number
      type !== undefined &&
      !ents.core.common.value.types.Intrinsic.ForNumber.isForNumber(type)
    ) {
      return undefined
    }
    // Default for all numbers
    let format = '#,##0'

    // Sets the precision
    if (precision !== undefined && precision > 0) {
      format += `.${'0'.repeat(precision)}`
    }

    // Adds any desired symbols based on the type
    if (type === ents.core.common.value.types.Intrinsic.Currency) {
      format = `$${format}`
    } else if (type === ents.core.common.value.types.Intrinsic.Percent) {
      format = `${format}%`
    }
    return format
  }
}
